/**
 * The small blue dot on a map-rail button that says "this button's layers are
 * on", so a user can tell without opening its menu.
 *
 * Shared by the Layers button in `MapControls` and the Annotations button, so the
 * two buttons side by side carry the identical dot. The parent must be
 * `position: relative`; the dot sits over its top-right corner, and its ring in
 * the page background colour keeps it apart from the button's own border.
 *
 * Decorative: the button it sits on carries the accessible name.
 */
export const ActiveLayersDot = () => (
  <span
    aria-hidden
    data-testid="active-layers-dot"
    css={theme => ({
      position: 'absolute',
      top: -2,
      right: -2,
      width: 10,
      height: 10,
      borderRadius: theme.radius.RadiusFull,
      backgroundColor: theme.semantic.ColorAccentDefault,
      border: `2px solid ${theme.semantic.ColorBackgroundDefault}`,
      pointerEvents: 'none',
    })}
  />
)
